import * as React from "react";
import { FC, ComponentProps } from "react";
import { AvatarSizes } from "~/sharedComponents/avatar/SpriteAvatar";
import { icon } from "~/sharedComponents/icons";
import { Button } from "../Button";
import { ButtonFlag, ButtonVariants } from "../Enums";

type Props = ComponentProps<typeof Button> & {
    IsExpanded: boolean;
};

/**
 * Rewrites ButtonFlag.With_icon width: 28px;
 * Must be equal to the overall width of the entity thumbnail to be aligned to.
 * For workload grid, this is the size of the avatar and is the largest value of all possible entity thumbnails.
 */
export const ExpandCollapseButtonWidth = AvatarSizes.Small;

export const ExpandCollapseButton: FC<Props> = props => {
    const { IsExpanded, style, ...rest } = props;

    return (
        <Button
            {...rest}
            iconName={IsExpanded ? icon.chevron_down_small : icon.chevron_right_small}
            iconSize={rest.isLoading ? "small" : "default"}
            style={{ width: ExpandCollapseButtonWidth, ...style }}
            variant={ButtonVariants.Inline}
            flags={ButtonFlag.With_icon}
        />
    );
};
